module.exports = __webpack_public_path__ + "img/62_M4_climate_doesnt_care.9fee2b4b.jpg";